import React, { useCallback, useEffect } from "react";
import { RecruiterActivity } from "redux/models/recruiterActivity";
import { useAPIRequest } from "hooks/useAPIRequest";
import { Divider } from "antd";
import { Section } from "features/dashboard/components/section";
import { SectionError } from "features/dashboard/components/sectionError";
import { PieChart } from "features/dashboard/sections/postOfferMetrics/pieChart/pieChart";
import { FalloutRates } from "features/dashboard/sections/postOfferMetrics/falloutRates/falloutRates";
import * as styles from "features/dashboard/sections/postOfferMetrics/postOfferMetrics.module.scss";

export const PostOfferMetrics = React.memo(({ clientId, recruiterId }) => {
  const fetchCallback = useCallback(async () => {
    return RecruiterActivity.monthlyOfferMetrics(clientId, recruiterId, false);
  }, [clientId, recruiterId]);

  const {
    data,
    loading,
    error,
    execute: fetchMetrics,
    reset,
  } = useAPIRequest(fetchCallback, { initialLoading: true });

  const renderContent = () => {
    if (!clientId || !recruiterId) {
      return (
        <div className={styles.postOfferMetrics__emptyState}>
          Please select a client and recruiter to view post-offer metrics.
        </div>
      );
    }

    if (error && !loading) {
      return <SectionError message={error.message} onRetry={fetchMetrics} />;
    }

    return (
      <div className={styles.postOfferMetrics}>
        <h3 className={styles.postOfferMetrics__chartTitle}>
          Offer Fallout Reasons
        </h3>
        <div className={styles.postOfferMetrics__chartSection}>
          <PieChart
            falloutReasons={data?.falloutReasons || []}
            loading={loading}
          />
        </div>
        <Divider style={{ margin: 0 }} />
        <div className={styles.postOfferMetrics__ratesSection}>
          <FalloutRates
            offerFallouts={data?.offerFallouts || 0}
            offersExtended={data?.offersExtended || 0}
            interviewNoShows={data?.interviewNoShows || 0}
            interviewsScheduled={data?.interviewsScheduled || 0}
            loading={loading}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!clientId || !recruiterId) {
      reset();
      return;
    }
    fetchMetrics();
  }, [clientId, recruiterId, fetchMetrics, reset]);

  return (
    <Section title="Monthly Performance Metrics" titleAlign="center">
      {renderContent()}
    </Section>
  );
});
